import { Dispatcher } from "flux";
import { ACTION_CONTEXT_KEY } from "./ContextedReduceStore";

class ContextedDispatcher extends Dispatcher {

    contextDispatch(context, payload) {
        payload[ACTION_CONTEXT_KEY] = context;
        super.dispatch(payload);
    }

}

export default ContextedDispatcher;



// WEBPACK FOOTER //
// ./app/data/util/ContextedDispatcher.js